export default __webpack_public_path__ + "static/media/Igualdad-Laboral.41f9b487.png";